import "./App.css";
import { useEffect, useState, useCallback } from "react";
import { Route, Routes, useNavigate, Navigate } from "react-router-dom";
import { signOut } from "@aws-amplify/auth";
import { getCurrentUser } from "aws-amplify/auth";

// Home
import Home from "./Screens/Home";
import About from "./Screens/About";
import Support from "./Screens/Support";

// Auth
import SignIn from "./Screens/SignIn";
import SignUp from "./Screens/SignUp";
// Dashboard
import DefaultLayout from "./Layout/DefaultLayout";
import Dashboard from "./Screens/Dashboard";
import SelectRecipient from "./Screens/SelectRecipient";
import AddRecipient from "./Screens/AddRecipient";
import Transactions from "./Screens/Transactions";
import MyAccount from "./Screens/MyAccount";
import Settings from "./Screens/Settings";
import SupportTicket from "./Screens/SupportTicket";
import Overview from "./Screens/OverView";
import RecipientDetail from "./Screens/RecipientDetail";
import SendMoney from "./Screens/SendMoney";
import ForgetPassword from "./Screens/ForgetPassword";

import FundWallet from "./Screens/FundWallet";
import KYCUser from "./Screens/KYCUser";

const DASHBOARD_VERIFY_PROMPT_TRIGGER_KEY =
  "dashboardVerificationPromptShouldShow";

function App() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const handleLoginSuccess = (options = {}) => {
    const { shouldShowVerificationPrompt = true } = options;
    setIsLoggedIn(true);
    const loginTimestamp = new Date().getTime().toString();
    localStorage.setItem("loginTimestamp", loginTimestamp);
    localStorage.setItem(
      DASHBOARD_VERIFY_PROMPT_TRIGGER_KEY,
      shouldShowVerificationPrompt ? "true" : "false",
    );
    navigate("/dashboard");
  };

  const checkLoginStatus = async () => {
    try {
      await getCurrentUser();
      setIsLoggedIn(true);
      localStorage.setItem("loginTimestamp", new Date().getTime().toString());
    } catch (error) {
      setIsLoggedIn(false);
      localStorage.removeItem("loginTimestamp");
      localStorage.removeItem(DASHBOARD_VERIFY_PROMPT_TRIGGER_KEY);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkLoginStatus();
  }, []);

  const logoutUser = useCallback(async () => {
    try {
      await signOut();
    } catch (error) {
      console.log("error signing out: ", error);
    } finally {
      localStorage.removeItem("loginTimestamp");
      localStorage.removeItem(DASHBOARD_VERIFY_PROMPT_TRIGGER_KEY);
      setIsLoggedIn(false);
      navigate("/signIn");
    }
  }, [navigate]);

  useEffect(() => {
    if (!isLoggedIn) return undefined;

    let logoutTimer;
    const INACTIVITY_TIMEOUT_MS = 60 * 60 * 1000; // 60 minutes

    const resetTimer = () => {
      clearTimeout(logoutTimer);
      logoutTimer = setTimeout(logoutUser, INACTIVITY_TIMEOUT_MS);
      localStorage.setItem("loginTimestamp", new Date().getTime().toString());
    };

    resetTimer();

    const activityEvents = [
      "mousemove",
      "mousedown",
      "keypress",
      "touchmove",
      "touchstart",
      "scroll",
      "wheel",
      "click",
    ];
    activityEvents.forEach((eventName) =>
      window.addEventListener(eventName, resetTimer),
    );

    return () => {
      clearTimeout(logoutTimer);
      activityEvents.forEach((eventName) =>
        window.removeEventListener(eventName, resetTimer),
      );
    };
  }, [isLoggedIn, logoutUser]);
  return (
    <div className="App">
      {!loading && (
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/support" element={<Support />} />

          {isLoggedIn ? (
            <Route element={<DefaultLayout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/selectRecipient" element={<SelectRecipient />} />
              <Route path="/myAccount" element={<MyAccount />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/supportTicket" element={<SupportTicket />} />
              <Route path="/addRecipient" element={<AddRecipient />} />
              <Route path="/transactions" element={<Transactions />} />
              <Route path="/overView" element={<Overview />} />
              <Route path="/fundWallet" element={<FundWallet />} />
              <Route path="/kycuser" element={<KYCUser />} />

              <Route path="/recipients" element={<SelectRecipient />} />
              <Route path="/recipientDetail" element={<RecipientDetail />} />
              <Route path="/sendMoney" element={<SendMoney />} />

              <Route path="*" element={<Navigate to="/dashboard" />} />
            </Route>
          ) : (
            <>
              <Route path="/" element={<Home />} />
              <Route
                path="/signIn"
                element={<SignIn onLoginSuccess={handleLoginSuccess} />}
              />
              <Route
                path="/signup"
                element={<SignUp onLoginSuccess={handleLoginSuccess} />}
              />
              <Route path="/forgetPassword" element={<ForgetPassword />} />
              <Route path="*" element={<Navigate to="/" />} />

              {/* <Route/> */}
            </>
          )}
        </Routes>
      )}
    </div>
  );
}

export default App;
